
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import _ from 'lodash';
    import * as Publicaciones from '@/__env/lib/MercadoLibre/Publicaciones';
    import * as Articulos from '@/__env/lib/Articulos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Publicacion } from '@/__env/lib/MercadoLibre/Publicaciones';
    import { Cuenta } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';
    import { Wait } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }

        public Abierto: boolean = false;

        mounted()
        {
            this.Cuenta = '';
            this.Tipo = this.Tipos[0];
            this.CoeficientePrecio = 0;
            this.CoeficienteStock = 0;
        }

        public Cuenta: string = '';
        public Tipo: { Nombre: string, Tipo: Publicaciones.Tipos; } = null;
        public Tipos: { Nombre: string, Tipo: Publicaciones.Tipos; }[] = [
            { Nombre: 'Igual que la original', Tipo: null },
            { Nombre: 'Normal', Tipo: Publicaciones.Tipos.Normal },
            { Nombre: 'Financiada', Tipo: Publicaciones.Tipos.Financiada }
        ];
        public CoeficientePrecio: number = 0;
        public CoeficienteStock: number = 0;

        public get Ok()
        {
            return this.Tipo && this.Cuenta &&
                this.CoeficientePrecio > -30 && this.CoeficientePrecio < 50 &&
                this.CoeficienteStock > -30 && this.CoeficienteStock < 50
                && this.Seleccionados.hasRows();
        }

        public async Ejecutar()
        {
            if ( await Utiles.Mensajes.SiNo( 'Copiar publicaciones', `¿Copiar ${this.Seleccionados.length} publicaciones a la cuenta ${this.Cuenta}?` ) )
            {

                this.Cargando = true;
                if ( this.Ok )
                {
                    this.TotalSincronizarTodo = this.Seleccionados.length;
                    this.VaSincronizarTodo = 0;
                    for ( let e of this.Seleccionados )
                    {

                        let precio = e.Precio;
                        let stock = e.Stock + e.Ventas;
                        let tipo = this.Tipo.Tipo ? this.Tipo.Tipo.Id : null;

                        if ( this.CoeficientePrecio > 0 )
                            precio = Math.round( precio * ( 1 + ( this.CoeficientePrecio / 100 ) ) );
                        else if ( this.CoeficientePrecio < 0 )
                            precio = Math.round( precio / ( 1 + Math.abs( ( this.CoeficientePrecio / 100 ) ) ) );

                        if ( this.CoeficienteStock > 0 )
                            stock = Math.round( stock * ( 1 + ( this.CoeficienteStock / 100 ) ) );
                        else if ( this.CoeficienteStock < 0 )
                            stock = Math.round( stock / ( 1 + Math.abs( ( this.CoeficienteStock / 100 ) ) ) );

                        let a = await e.Duplicar( this.Cuenta, precio, stock, tipo );
                        if ( a )
                        {
                            this.IdSincronizarTodo = e.Id;
                            this.VaSincronizarTodo++;

                        } else
                        {

                            this.IdSincronizarTodo = e.Id;
                            this.VaSincronizarTodo++;
                            this.Errores.push( { id: e.Id } );
                        }

                    }
                    Utiles.Notificaciones.Completado( 'Operación completada' );
                    await Wait( 100 );
                    this.Cargando = false;
                    //this.Controlador.Buscador.Filtros.Valores.Cuenta = this.Controlador.Buscador.Filtros.Cuentas.findIndex( x => x.Id == this.Cuenta );
                    this.Controlador.Buscador.Buscar( 1 );
                    this.Controlador.RecargarEstadistica();
                }

                this.Cargando = false;
                this.Cerrar();
            }


        }


        public Errores: any[] = [];
        public Cargando: boolean = false;
        public TotalSincronizarTodo: number = 0;
        public IdSincronizarTodo: string = '';
        public VaSincronizarTodo: number = 0;
        public SocketSincronizarTodo: string = '';

        public async Cerrar()
        {
            this.$emit( 'cerrar' );
            this.Abierto = false;

        }
    }
